const initialState = {
  channels: [],
  page: 1,
  filtersFormState: {
    data: {
      accounts: [],
    }
  },
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_CHANNELS': {
      const { channels, page } = payload;
      return {
        ...state,
        channels,
        page,
      };
    }
    case 'CHANNEL_FILTERS_CHANGE': {
      const { filtersFormState } = payload;
      return {
        ...state,
        filtersFormState,
        page: 1,
      };
    }
    case 'CHANNELS_NEXT_PAGE': {
      const page = Number(state.page);
      return {
        ...state,
        page: page + 1,
      };
    }
    case 'CHANNELS_PREVIOUS_PAGE': {
      const page = Number(state.page);
      return {
        ...state,
        page: page > 1 ? page - 1 : 1,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Channels/Channels.reducer.js